import type { EnteredSerial } from '@/pages/purchase/grn/components/SerialEntryModal';

export interface SmartItemOption {
  id: string;
  name: string;
  code: string;
  barcode: string;
  unitName: string;
  hsnCode: string;
  purchaseRate: number;
  currentStock: number;
  isSerialTracked?: boolean;
  isBatchTracked?: boolean;
  serialPrefix?: string | null;
  defaultWarrantyMonths?: number | null;
  requiresIncomingQC?: boolean;
}

export interface SmartRowData {
  id: string;
  itemId: string;
  itemName: string;
  hsnCode: string;
  barcode: string;
  qty: number;
  /** The item's stock unit; qty and rate are in enteredUnitId when that is set (2 Ton for an item in Kg) */
  unit: string;
  enteredUnitId?: string | null;
  rate: number;
  total: number;
  batchNumber?: string;
  isAutoBatch?: boolean;
  mfgDate?: string;
  expiryDate?: string;
  isSerialTracked?: boolean;
  isBatchTracked?: boolean;
  serialPrefix?: string | null;
  defaultWarrantyMonths?: number | null;
  requiresIncomingQC?: boolean;
  serials?: EnteredSerial[];
}

export const makeSmartRow = (): SmartRowData => ({
  id: `row-${Date.now()}-${Math.random()}`,
  itemId: '',
  itemName: '',
  hsnCode: '',
  barcode: '',
  qty: 1,
  unit: '',
  rate: 0,
  total: 0,
  batchNumber: '',
  isAutoBatch: false,
  mfgDate: new Date().toISOString().split('T')[0],
  expiryDate: '',
  isSerialTracked: false,
  isBatchTracked: false,
  requiresIncomingQC: false,
  serials: [],
});
